import React from 'react';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';

const DEFAULT_DELAY_MS = 750;

export default class DelayedInput extends Base {
  constructor(props) {
    super(props);

    this.timerId = null;

    this.state = {
      value: this.props.value,
    };
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  propagateNow() {
    this.props.onUpdate && this.props.onUpdate({ value: this.state.value });
  }

  clearTimer() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }

  @autobind
  onChange(e) {
    this.clearTimer();

    this.setState({
      value: e.target.value,
    });

    var delay =
      typeof this.props.delay === 'number'
        ? this.props.delay
        : DEFAULT_DELAY_MS;
    this.timerId = setTimeout(() => this.propagateNow(), delay);

    // Sync method that does not wait to be defered. This might be useful
    // if you want to start a loader before we do the actual server call.
    this.props.onSyncUpdate &&
      this.props.onSyncUpdate({ value: e.target.value });
  }

  // NB! onKeyUp() does not fire on mobile safari under some circumstances. Using onKeyPress instead.
  @autobind
  onKeyPress(e) {
    if (e.keyCode == 13) {
      this.clearTimer();
      this.propagateNow();
    }
  }

  render() {
    return (
      <input
        ref="inputfield"
        {...this.props}
        onChange={this.onChange}
        onKeyPress={this.onKeyPress}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/common/delayed-input/delayed-input.es6